var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126mm",
    height: "20mm",
    viewBox: "0 0 126 20",
    id: "svg5",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#999999",
      fillOpacity: 1,
      strokeWidth: 0.238456
    },
    id: "circle10019",
    cx: 114.38583,
    cy: 5.492826,
    r: 3.7241769
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2c9460",
      fillOpacity: 1,
      strokeWidth: 0.238456
    },
    id: "path1040",
    cx: 22.133692,
    cy: 5.492826,
    r: 3.7241769
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.03401px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.10085
    },
    x: 113.28452,
    y: 6.890626,
    id: "text21940"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan21938",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "#ffffff",
      strokeWidth: 0.10085
    },
    x: 113.28452,
    y: 6.890626
  }, "3")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 27.686043,5.67937 35.02137,-0.061",
    id: "path28343"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 73.812109,5.67937 35.021371,-0.061",
    id: "path28749"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#1a1a1a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    x: 2.3551147,
    y: 16.960264,
    id: "text34273"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan34271",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#1a1a1a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    x: 2.3551147,
    y: 16.960264
  }, "Pilih Tanggal dan Waktu")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    x: 58.208553,
    y: 16.960264,
    id: "text35513"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan35511",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    x: 58.208553,
    y: 16.960264
  }, "Data Pasien")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#999999",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    x: 104.81323,
    y: 16.960264,
    id: "text37545"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan37543",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76393px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      whiteSpace: "normal",
      vectorEffect: "none",
      fill: "#999999",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0940983,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    x: 104.81323,
    y: 16.960264
  }, "Konfirmasi")), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2c9460",
      fillOpacity: 1,
      strokeWidth: 0.238456
    },
    id: "circle17302",
    cx: 68.259766,
    cy: 5.492826,
    r: 3.7241769
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.03401px",
      lineHeight: 1.25,
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.10085
    },
    x: 67.158463,
    y: 6.890626,
    id: "text17306"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan17304",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.10085
    },
    x: 67.158463,
    y: 6.890626
  }, "2")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 20.201655,5.6244754 1.269794,1.3090432 2.59428,-3.0013966",
    id: "path16340"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.4dd8db9c8461e1ced612ea0b04256601.svg";
export { ForwardRef as ReactComponent };